import React from 'react'
import { HashRouter, Routes, Route } from "react-router-dom";
import Home from './Home'
import SingleMovie from './SingleMovie'
import Error from './Error'
import "./App.css";


function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="movie/:id" element={<SingleMovie />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </HashRouter>
  )
}

export default App
